<template>
  <div id="app">
    <!--
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
      <router-view/>
    </div>-->
    <div v-if="showLoading" style="text-align:center;padding-top: 40px">
      <div class="fa-10x">
        <i class="fas fa-spinner fa-spin"></i>
      </div>
    </div>
    <Landingpage v-if="showLandingpage" />
    <DefaultTemplate v-if="template == 'default'" />
    <EspritTemplate v-if="template == 'esprit'" />
    <HellaTemplate v-if="template == 'hella'" />
    <NoTemplateMessage v-if="noTemplateMessage != null" />
    <GlobalError v-if="globalError != null" />
  </div>
</template>

<script>
import "./assets/js/all.min.js";
import axios from "axios";
import DefaultTemplate from "./templates/DefaultTemplate";
import EspritTemplate from "./templates/EspritTemplate";
import HellaTemplate from "./templates/HellaTemplate";
import NoTemplateMessage from "./templates/NoTemplateMessage";
import GlobalError from "./templates/GlobalError";
import Landingpage from "./views/Landingpage";

export default {
  name: "app",
  components: {
    DefaultTemplate,
    NoTemplateMessage,
    Landingpage,
    GlobalError,
    EspritTemplate,
    HellaTemplate
  },
  data: function() {
    return {
      globalError: null,
      noTemplateMessage: null,
      showLandingpage: false
    };
  },
  computed: {
    showLoading: function() {
      return (
        this.Session == null &&
        this.Company == null &&
        this.globalError == null &&
        this.noTemplateMessage == null &&
        !this.showLandingpage
      );
    },
    template: function() {
      if (this.Company != null) {
        return this.Company.Template;
      }

      return null;
    }
  },
  mounted: function() {
    //check query lang
    if (this.$route.query.lang != undefined) {
      if (this.LanguageStrings[this.$route.query.lang] != undefined) {
        this.GS.Language = this.$route.query.lang;
      }
    }
    if (this.$route.query.tan != undefined) {
      this.GS.Tan = this.$route.query.tan;
    }
    if (this.$route.query.credentialmode != undefined) {
      this.GS.CredentialMode = true;
    }
    if (this.$route.query.email != undefined) {
      this.GS.PrefilledMail = this.$route.query.email;
    }
    if (this.$route.query.checkbox1 != undefined) {
        if(this.$route.query.checkbox1 == "true" )
        {
          this.GS.Checkbox1Prefill = 1;
        }
        else
        {
          if(new RegExp("[0-9]").exec(this.$route.query.checkbox1 + "") != null)
          {
            this.GS.Checkbox1Prefill = this.$route.query.checkbox1;
          }
        }
    }
    //Load sessionInfo
    //______________________________________________________________________________________________________________________
    if (this.$route.query.session != undefined) {
      var self = this;
      axios
        .post(
          this.GS.Endpoint + "/v2/sessioninfo/" + this.$route.query.session,
          {},
          {}
        )
        .then(function(response) {
          //self.sessionInfo = response.data;
          self.GS.Session = response.data;
          self.GS.Company = response.data.Company;
          self.applyCompanyCI();
          if (self.$route.path == "/login") {
            if (response.data.Unregistered == true) {
              if (response.data.Company.RegisterMode == 0) {
                self.GS.Tan = response.data.Tan;
              }
              self.$router.push("/register");
            } else {
              self.$router.push("/login");
            }
          }
        })
        .catch(function(response) {
          //console.log(response);
          if (response.response == undefined) {
            self.globalError = "internalservererror";
            return;
          }
          if (response.response.status == 404) {
            self.globalError = "sessionexpired";
            return;
          }
          self.globalError = "internalservererror";
          return;
        });
      return;
    } else {
      if (
        this.$route.path == "/login" ||
        this.$route.path == "/read"
      ) {
        this.noTemplateMessage = "sessionexpired";
        return;
      }
    }
    //______________________________________________________________________________________________________________________
    if (this.$route.path == "/activate") {
      var self = this;
      if (this.$route.query.code == undefined) {
        this.globalError = "internalservererror";
        return;
      }
      axios
        .post(
          this.GS.Endpoint + "/v2/activate/" + this.$route.query.code,
          {},
          {}
        )
        .then(function(response) {
          //self.sessionInfo = response.data;
          self.noTemplateMessage = "register_ok";
        })
        .catch(function(response) {
          if (response.response == undefined) {
            self.globalError = "internalservererror";
            return;
          }
          if (response.response.status == 409) {
            //self.globalError = "link_expired";
            self.noTemplateMessage = "register_ok";
            return;
          }

          self.globalError = "internalservererror";
          return;
        });
      return;
    }
    //______________________________________________________________________________________________________________________
    if (this.$route.path == "/changerequest") {
      var self = this;
      if (this.$route.query.code == undefined) {
        this.globalError = "internalservererror";
        return;
      }
      axios
        .post(
          this.GS.Endpoint + "/v2/changerequest/" + this.$route.query.code,
          {},
          {}
        )
        .then(function(response) {
          //self.sessionInfo = response.data;
          self.noTemplateMessage = response.data;
        })
        .catch(function(response) {
          if (response.response == undefined) {
            self.globalError = "internalservererror";
            return;
          }
          if (response.response.status == 409) {
            self.globalError = "link_expired";
            return;
          }

          self.globalError = "internalservererror";
          return;
        });
      return;
    }
    //______________________________________________________________________________________________________________________
    if (this.$route.path == "/passwordchange") {
      var self = this;
      if (this.$route.query.code == undefined) {
        this.globalError = "internalservererror";
        return;
      }
      else
      {
        this.GS.RequestCode = this.$route.query.code;
      }
      axios
        .post(
          this.GS.Endpoint + "/v2/companyinfobyrequest/" + this.$route.query.code,
          {},
          {}
        )
        .then(function(response) {
            self.GS.Company = response.data.Company;
            self.applyCompanyCI();
        })
        .catch(function(response) {
          if (response.response == undefined) {
            self.globalError = "internalservererror";
            return;
          }
          if (response.response.status == 409 || response.response.status == 404) {
            self.globalError = "link_expired";
            return;
          }

          self.globalError = "internalservererror";
          return;
        });
      return;
    }
    //______________________________________________________________________________________________________________________
    if (this.$route.path == "/") {
      this.showLandingpage = true;
      return;
    }
    if (this.$route.path == "/error") {
      this.globalError = "internalservererror";
      return;
    }
    if (this.$route.path == "/register") {
      this.globalError = "openregister";
      return;
    }
    //______________________________________________________________________________________________________________________
    if (
      this.$route.path != "/login" &&
      this.$route.path != "/register" &&
      this.$route.path != "/read" &&
      this.$route.path != "/activate" &&
      this.$route.path != "/changerequest" &&
      this.$route.path != "/"
    ) {
      var self = this;
      var s = window.location.pathname;
      var l=0;
      while(l < s.length && s[l] == '/')
      {   l++; }
      s = s.substring(l, s.length);

      axios
        .post(
          this.GS.Endpoint + "/v2/companyinfo/" + s,
          {},
          {}
        )
        .then(function(response) {
          //self.sessionInfo = response.data;

          if (response.data.Company.RegisterMode == 0) {
            self.showLandingpage = true;
          } else {
            self.GS.Company = response.data.Company;
            self.applyCompanyCI();
            self.$router.push("/register");
          }
        })
        .catch(function(response) {
          if (response.response == undefined) {
            self.globalError = "internalservererror";
            return;
          }
          self.showLandingpage = true;
        });
      return;
    }
  },
  methods: {
    applyCompanyCI: function() {
      document.getElementsByTagName(
        "body"
      )[0].style.backgroundColor = this.Company.CI_Bodybgcolor;
    }
  }
};
</script>

<style>
/*#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}*/
@media screen {

  #app {
    line-height: 1;
    font-family: Verdana, Arial, Helvetica, sans-serif;
    font-size: 13px;
  }
}
</style>
